import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '~/adapters/graphqlRequest';
import { appQueryClient } from '~/adapters/reactQuery';
import { CoachCommentsDocument, CoachCommentsQuery } from '~/gql/graphql';

export const commentsKeys = {
  allComments: () => ['coachComments'],
  comments: (input) => [...commentsKeys.allComments(), input],
};

type CommentsQueryInput = {
  companyId: number;
  surveyIds: number[];
  surveyElementIds?: number[];
  attributes?: { id: number; values: string[] }[];
  managerReportIds?: string[] | null;
  isHierarchyReport?: boolean | null;
  selectedTimeframe?: { startTimeUTC: string; endTimeUTC: string } | null;
};

export const commentsOptions = (input: CommentsQueryInput) => {
  return {
    queryKey: commentsKeys.comments(input),
    queryFn: async () => {
      const res = await graphqlRequest<{ data: CoachCommentsQuery }>(CoachCommentsDocument, input);
      return res.data;
    },
  };
};

export const useCoachCommentsQuery = (input: CommentsQueryInput) => {
  return useQuery(commentsOptions(input));
};

export const coachCommentsQuery = (input: CommentsQueryInput) => {
  return appQueryClient.fetchQuery(commentsOptions(input));
};
